import { useEffect, useState } from "react";
import {
    Table,
    Button,
    Tooltip,
    Typography,
} from "antd";
import { DeleteIcon, EditIcon } from "components/Icons";
import { DEFAULT_NUMBER_OF_ITEMS_IN_VIEW } from "config";
import { logUserEvent } from 'helpers/userEventLogger'
import { useOnlineContext } from 'helpers/contexts/OnlineContext/OnlineContext'
import { useEntityData } from "EntityDataContext/EntityDataContext";
import { getAssetDefinition } from "helpers/hierarchyHelpers";

const CopyAssetPane = ({ ASSET_COLUMNS, setCopyAsset, setCopyAssetMessage }) => {
    const {copyAssets, assets: assetData, userData: { email }, syncStatusHook: { imagesToUploadCount }} = useEntityData()

    const { isOnline } = useOnlineContext()

    const [listCopy, setListCopy] = copyAssets
    const [assets, setAssets] = useState([])

    function getKnownAsNameFromHierarchy(id) {
        const assetType = getAssetDefinition(id, window.hierarchy || [])

        return assetType?.knownAs || undefined
    }

    const actions = (asset) => [
        <Tooltip title="Edit" key="edit">
            <Button
                type="clear"
                icon={<EditIcon />}
                onClick={(e) => {
                    e.stopPropagation();
                    const { id } = asset

                    logUserEvent({
                        user: email,
                        eventType: `Copy Asset Review panel - Asset ${id} Edit selected from copy asset listing`,
                        imageOutboxSize: imagesToUploadCount
                    }, isOnline)

                    setCopyAsset(asset);
                }}
            />
        </Tooltip>,
        <Tooltip title="Remove" key="cancel">
            <Button
                type="clear"
                onClick={(e) => {
                    const { id } = asset

                    if (listCopy.length === 1) setCopyAssetMessage(listCopy[0])

                    logUserEvent({
                        user: email,
                        eventType: `Copy Asset Review panel - Asset ${id} removed from copy asset listing`,
                        imageOutboxSize: imagesToUploadCount
                    }, isOnline)
                    
                    setListCopy(listCopy.filter((a) => a !== asset.id))
                }}
                icon={<DeleteIcon />}
            />
        </Tooltip>,
    ];

    const action =
    {
        title: "",
        fixed: "right",
        render: (asset) => {
            return <div className="row-actions">{actions(asset)}</div>;
        },
    }

    const copyAssetsList = async () => {
        if (listCopy.length <= 0) {
            setAssets([])
            return
        }

        const enhancedAssets = listCopy.map((assetId) => {
            const asset = assetData.items[assetId]
            const eliasId = asset?.assetType?.eliasID
            const knownAsName = getKnownAsNameFromHierarchy(eliasId) || undefined

            return {
                ...asset,
                name: knownAsName || asset.assetType?.description,
                quantity: asset.facets?.quantity,
                installDate: asset.facets && asset.facets["install-date"],
                manufacturer: asset.facets?.manufacturer,
            }
        })

        setAssets(enhancedAssets)
    }

    useEffect(() => {
        copyAssetsList()
    }, [listCopy])


    const newColumns = [ASSET_COLUMNS[0], ASSET_COLUMNS[1], ASSET_COLUMNS[3], ASSET_COLUMNS[5], action]

    return (<>
        <div className="table-header" style={{ paddingTop: 20 }}>
            {assets.length > 0 && <Typography.Title className="subtitle" level={1}>
                Copy Asset Review
                <Typography.Text className="results">
                    {" "}
                    - {assets.length} remaining to review
                </Typography.Text>
            </Typography.Title>}
        </div>
        {assets.length > 0 && (
            <Table
                scroll={{ x: "max-content" }}
                rowKey="id"
                dataSource={assets}
                showSorterTooltip={false}
                columns={newColumns}
                pagination={{ pageSize: DEFAULT_NUMBER_OF_ITEMS_IN_VIEW, hideOnSinglePage: true }}
                style={{ paddingBottom: 20 }}
            />
        )}</>
    )
}

export default CopyAssetPane